import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const Ul = styled.ul`
    list-style: none;
    display: flex;
    flex-direction: row;
    
    li {
        padding: 33px 20px 33px 20px;
    }

    @media (max-width: 980px) {
        display:none;
    }

    a{
        
        font-weight: bold;
        font-size: 16px;
        text-decoration: none;
        color: #095EB2;
        transition: all 0.9s;
    }
    props.bg{
        background-color: #095EB2;
        color: white;
    }
    a:hover{
        color: white;
        background-color: #095EB2;
    }

`;

const RightNav = (props) => {
    return(
        <Ul bg={props.bg}>
            <Link to='/' id="l1"><li >Início</li></Link>
            <Link to={
                                {
                                    pathname:'/homologacao',
                                    state: {
                                        value: 0
                                    }
                                }
                    } id='l2'><li>Homologação</li></Link>
            <Link to={
                                {
                                    pathname:'/reconhecimento',
                                    state: {
                                        value: 4
                                    }
                                }
                    } id='l3'><li>Reconhecimento</li></Link>
            <Link to='/contacto' id='l4'><li>Contactos</li></Link>
        </Ul>
        
    )
}

export default RightNav;